module.exports = __webpack_public_path__ + "static/media/free-1.cb029b19.jpg";